var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "format align left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5003 1.78043H1.50033C1.0281 1.78043 0.666992 1.41932 0.666992 0.947102C0.666992 0.47488 1.0281 0.11377 1.50033 0.11377H16.5003C16.9725 0.11377 17.3337 0.47488 17.3337 0.947102C17.3337 1.41932 16.9725 1.78043 16.5003 1.78043Z",
    fill: "#464255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5003 6.22486H1.50033C1.0281 6.22486 0.666992 5.86375 0.666992 5.39153C0.666992 4.91931 1.0281 4.5582 1.50033 4.5582H11.5003C11.9725 4.5582 12.3337 4.91931 12.3337 5.39153C12.3337 5.86375 11.9725 6.22486 11.5003 6.22486Z",
    fill: "#464255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5003 10.6693H1.50033C1.0281 10.6693 0.666992 10.3082 0.666992 9.83596C0.666992 9.36374 1.0281 9.00262 1.50033 9.00262H16.5003C16.9725 9.00262 17.3337 9.36374 17.3337 9.83596C17.3337 10.3082 16.9725 10.6693 16.5003 10.6693Z",
    fill: "#464255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.5003 15.1137H1.50033C1.0281 15.1137 0.666992 14.7526 0.666992 14.2804C0.666992 13.8082 1.0281 13.4471 1.50033 13.4471H11.5003C11.9725 13.4471 12.3337 13.8082 12.3337 14.2804C12.3337 14.7526 11.9725 15.1137 11.5003 15.1137Z",
    fill: "#464255"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.9f33af047cb4d19b427249aea1a317ff.svg";
export { ForwardRef as ReactComponent };